// NotificationContext.js
import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const [type, setType] = useState('success');

  const notify = (msg, type = 'success') => {
    setMessage(msg);
    setType(type);
    setTimeout(() => setMessage(null), 2500); // ascunde automat
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
     {message && (
  <div style={{
    position: 'fixed',
    top: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: type === 'success' ? '#4caf50' : '#f44336',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '6px',
    zIndex: 999999,
    fontSize: '1rem'
  }}>
    {type === 'success' ? '✅' : '❌'} {message}
  </div>
)}

    </NotificationContext.Provider>
  );
};
